import { useColorModeValue } from "@chakra-ui/react";

export const colors = {
  wt: "#eeeeee",
  primary: "#000000",
  secondary: "#F56565",
  gray50: "rgba(0, 0, 0, 0.5)",
  white: "#FFFFFF",
  lightGray: "#CBD5E0",
  dividerColor: "#F2F3F5",
  "cloud-white": "#F2F3F5",
  "light-smoke": "#F5F5F5",
  secondaryScheme: {
    50: "#ffe5e5",
    100: "#fcbaba",
    200: "#f28f8f",
    300: "#e86464",
    400: "#de3939",
    500: "#F56565",
    600: "#c44444",
    700: "#933333",
    800: "#622222",
    900: "#311111",
  },
};

export const useDarkWhiteColor = () => {
  return useColorModeValue("white", "black");
};

export const useBgHover = () => {
  return useColorModeValue("#ebedf0", "#ebedf020");
};

export const useBgBaseColor = () => {
  return useColorModeValue("#F5F5F5", "#121212");
};

export const useBorderColor = () => {
  return useColorModeValue("gray.300", "RGBA(255, 255, 255, 0.24)");
};

export const useRedSoftPrimary = () => {
  return useColorModeValue("red.100", "#63171B80");
};

export const useDividerColor = () => {
  return useColorModeValue("#F2F3F5", "#444444");
};

export const useReverseDarkWhite = () => {
  return useColorModeValue("black", "white");
};

export const useCheckboxColor = () => {
  return useColorModeValue("#00000080", "#FFFFFF80");
};

export const useBgHighlightLanding = () => {
  return useColorModeValue("#F8F3F0", "#5C504890");
};
